import { render, staticRenderFns } from "./ProfileStats.vue?vue&type=template&id=5f173c54&scoped=true"
import script from "./ProfileStats.vue?vue&type=script&lang=js"
export * from "./ProfileStats.vue?vue&type=script&lang=js"
import style0 from "./ProfileStats.vue?vue&type=style&index=0&id=5f173c54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f173c54",
  null
  
)

export default component.exports